module.exports = __webpack_public_path__ + "img/burger-1.e601b09a.jpg";